import apiClient from './axiosConfig'; // Import apiClient
import { API_ENDPOINTS } from '../constants';

// Removed individual caching logic, now handled by axiosConfig interceptors

const fetchProjects = async (params = {}) => {
  const query = new URLSearchParams();
  if (params.paginate) query.append('paginate', params.paginate);
  if (params.limit) query.append('limit', params.limit);
  if (params.per_page) query.append('per_page', params.per_page);
  if (params.page) query.append('page', params.page);

  try {
    const response = await apiClient.get(`${API_ENDPOINTS.PROJECTS}?${query.toString()}`); // Use apiClient.get
    return response.data; // Axios wraps response in .data
  } catch (error) {
    console.error('Error fetching Projects data:', error);
    throw error;
  }
};

const fetchProjectDetail = async (slug) => {
  // Project detail pages are dynamic, so not caching here.
  // Caching for individual project details might be more complex if content changes frequently.
  try {
    const response = await apiClient.get(API_ENDPOINTS.PROJECT_DETAIL(slug)); // Use apiClient.get
    return response.data; // Axios wraps response in .data
  } catch (error) {
    console.error('Error fetching project detail:', error);
    throw error;
  }
};

const fetchProjectSkills = async (slug) => {
  // Removed individual caching logic, now handled by axiosConfig interceptors
  try {
    const response = await apiClient.get(API_ENDPOINTS.PROJECT_SKILLS(slug)); // Use apiClient.get
    return response.data; // Axios wraps response in .data
  } catch (error) {
    console.error('Error fetching Project skills:', error);
    throw error;
  }
};

export { fetchProjects, fetchProjectDetail, fetchProjectSkills };